/**
 * Meeting Section API Endpoints
 * Handles communication with /api/v2/teacher/meeting/sections/{module_id}
 */

import apiClient from "../apiClient";
import { MeetingSectionsResponse } from "@/types/meeting-section.types";

/**
 * Fetch meeting sections by module ID
 * GET /teacher/meeting/sections/{module_id}
 * Note: BASE_URL already includes /api/v2/
 */
export const fetchMeetingSections = async (
  moduleId: string
): Promise<MeetingSectionsResponse> => {
  const response = await apiClient.get<MeetingSectionsResponse>(
    `/teacher/meeting/sections/${moduleId}`
  );
  return response;
};
